import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import toast, { Toaster } from 'react-hot-toast';
import CheckToken from "../../_Login/CheckToken";
import fetchWithRetries from "../../Tools/FetchWithRetries";
import GetChopperByID from "../Tools/ChoppersGetChopperByID";
import GetMaterialTypes from "../Tools/ChoppersGetMaterialTypes";
import GetChopperModels from "../Tools/ChoppersGetModels";
import GetChopperModelDuties from "../Tools/ChoppersGetChopperModelDuties";
import GetMotorPositions from "../Tools/ChoppersGetMotorPositions";
import GetCutterHeadPositions from "../Tools/ChoppersGetCutterHeadPositions";
import GetCutterMountingArrangements from "../Tools/ChoppersGetCutterMountingArrangements";
import GetTrimRemovalMethods from "../Tools/ChoppersGetTrimRemovalMethods";
import CreateUpdateChoppers from "../Tools/ChoppersCreateUpdateChoppers";

const ChoppersDetail = () => {

    const { id } = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();

    const [chopper, setChopper] = useState({});

    const [motorPositions, setMotorPositions] = useState([]);
    const [cutterHeadPositions, setCutterHeadPositions] = useState([]);
    const [cutterMountingArrangements, setCutterMountingArrangements] = useState([]);
    const [trimRemovalMethods, setTrimRemovalMethods] = useState([]);

    const [materialTypes, setMaterialTypes] = useState([]);
    const [chopperModels, setChopperModels] = useState([]);
    const [chopperModelDuties, setChopperModelDuties] = useState([]);

    const [selectedMotorPosition, setSelectedMotorPosition] = useState({});
    const [selectedCutterHeadPosition, setSelectedCutterHeadPosition] = useState({});
    const [selectedCutterMountingArrangement, setSelectedCutterMountingArrangement] = useState({});
    const [selectedTrimRemoval, setSelectedTrimRemoval] = useState({});
    const [selectedModel, setSelectedModel] = useState(null);

    const [cutterRotatingSpeed, setCutterRotatingSpeed] = useState(0); // calculated RPM, updated whenever MaterialSpeed, DesiredPieceSize, or BladesInCutter changes

    //Get this chopper using the ID
    useEffect(() => {

        GetChopperByID(id).then((response) => {
            if (response.success) {

                let myChopper = JSON.parse(response.payload).data[0]

                let chopper = {
                    ChopperID: myChopper[0],
                    ChopperName: myChopper[1],
                    CreatedByID: myChopper[2],
                    CreatedByFirstName: myChopper[3],
                    CreatedByLastName: myChopper[4],
                    CreatedByUserName: myChopper[5],
                    CreatedByEmail: myChopper[6],
                    CreatedDate: myChopper[7],
                    ModifiedDate: myChopper[8],
                    ChopperModelID: myChopper[9],
                    //ChopperModelName: myChopper[10], // unimplemented
                    //ChopperModelManufacturerID: myChopper[11], // unimplemented
                    //ChopperModelManufacturerName: myChopper[12], // unimplemented
                    //ChopperModelAirCapacity: myChopper[13], // unimplemented
                    //ChopperModelInletWidth: myChopper[14], // unimplemented 
                    //ChopperModelMotorHP: myChopper[15], // unimplemented 
                    //ChopperModelMaxRPM: myChopper[16], // unimplemented 
                    //ChopperModelLink: myChopper[17], // unimplemented
                    MaterialTypeID: myChopper[18],
                    //MaterialTypeName: myChopper[19],
                    MaterialTypeDutyID: myChopper[20],
                    //MaterialTypeDutyName: myChopper[21], // unimplemented
                    MotorPositionID: myChopper[22],
                    //MotorPositionLetter: myChopper[23], // unimplemented
                    //MotorPositionDescription: myChopper[24], // unimplemented 
                    //MotorPositionPath: myChopper[25], // unimplemented
                    CutterHeadPositionID: myChopper[26],
                    //CutterHeadPositionLetter: myChopper[27], // unimplemented
                    //CutterHeadPositionDescription: myChopper[28], // unimplemented
                    //CutterHeadPositionPath: myChopper[29], // unimplemented
                    CutterMountingArrangementID: myChopper[30],
                    //CutterMountingArrangementLetter: myChopper[31], // unimplemented
                    //CutterMountingArrangementDescription: myChopper[32], // unimplemented
                    //CutterMountingArrangementPath: myChopper[33], // unimplemented
                    TrimRemovalMethodID: myChopper[34],
                    //TrimRemovalMethodLetter: myChopper[35], // unimplemented
                    //TrimRemovalMethodDescription: myChopper[36], // unimplemented
                    //TrimRemovalMethodPath: myChopper[37], // unimplemented
                    MaterialThickness: myChopper[38],
                    MaterialSpeed: myChopper[39],
                    MaterialWidth: myChopper[40],
                    InletDiameter: myChopper[41],
                    AirflowThroughCutter: myChopper[42],
                    BladesInCutter: myChopper[43],
                    DesiredPieceSize: myChopper[44],
                    CutterRotatingSpeed: myChopper[45],
                    PressureLoss: myChopper[46],
                    Knives: myChopper[47],
                    Bearings: myChopper[48],
                    OilMist: myChopper[49] == null || myChopper[49] == undefined || myChopper[49] == "" ? "" : (myChopper[49] == true || myChopper[49] == "True") ? 1 : 0,
                    TrimGeneratedBy: myChopper[50],
                    PaintColor: myChopper[51],
                    Voltage: myChopper[52],
                    FlyWheel: myChopper[53] == null || myChopper[53] == undefined || myChopper[53] == "" ? "" : (myChopper[53] == true || myChopper[53] == "True") ? 1 : 0,
                    TrimsPerMachine: myChopper[54],
                    NumberOfMachines: myChopper[55],
                    PaperGrades: myChopper[56],
                    Notes: myChopper[57]
                };

                setChopper(chopper);

            } else {
                toast.error("Chopper not found");
                //navigate("/Choppers");
            }
        });
    }, [id]);

    // Get motor positions
    useEffect(() => {

        fetchWithRetries(3, GetMotorPositions, (payload) => {

            let myMotorPositions = JSON.parse(payload).data;

            let motorPositionsList = myMotorPositions.map(mp => (
                {
                    "id": mp[0],
                    "Letter": mp[1],
                    "Description": mp[2],
                    "Path": mp[3]
                }
            ));

            setMotorPositions(motorPositionsList);

        });

    }, []);

    //Get cutter head positions
    useEffect(() => {

        fetchWithRetries(3, GetCutterHeadPositions, (payload) => {

            let myCutterHeadPositions = JSON.parse(payload).data;

            let cutterHeadPositionsList = myCutterHeadPositions.map(chp => (
                {
                    "id": chp[0],
                    "Letter": chp[1],
                    "Description": chp[2],
                    "Path": chp[3]
                }
            ));

            setCutterHeadPositions(cutterHeadPositionsList);

        });

    }, []);

    //Get cutter mounting arrangements
    useEffect(() => {

        fetchWithRetries(3, GetCutterMountingArrangements, (payload) => {

            let myCutterMountingArrangements = JSON.parse(payload).data;

            let cutterMountingArrangementsList = myCutterMountingArrangements.map(cma => (

                {
                    "id": cma[0],
                    "Letter": cma[1],
                    "Description": cma[2],
                    "Path": cma[3]
                }
            ));

            setCutterMountingArrangements(cutterMountingArrangementsList);

        });

    }, []);

    //Get trim removal methods
    useEffect(() => {

        fetchWithRetries(3, GetTrimRemovalMethods, (payload) => {

            let mytrimRemovalMethods = JSON.parse(payload).data;

            let trimRemovalMethodsList = mytrimRemovalMethods.map(tr => (
                {
                    "id": tr[0],
                    "Letter": tr[1],
                    "Description": tr[2],
                    "Path": tr[3]
                }
            ));

            setTrimRemovalMethods(trimRemovalMethodsList);

        });

    }, []);

    //Get chopper models
    useEffect(() => {

        fetchWithRetries(3, GetChopperModels, (payload) => {

            let myModels = JSON.parse(payload).data;

            let modelList = myModels.map(cm => (
                {
                    id: cm[0],
                    ManufacturerID: cm[1],
                    ManufacturerName: cm[2],
                    ModelName: cm[3],
                    AirCapacity: cm[4],
                    InletWidth: cm[5],
                    MotorHP: cm[6],
                    MaxRPM: cm[7],
                    Link: cm[8],
                    Duty: []
                }
            ));

            setChopperModels(modelList);

        });


    }, []);

    // Get chopper model duties
    useEffect(() => {

        fetchWithRetries(3, GetChopperModelDuties, (payload) => {
            let myChopperModelDuties = JSON.parse(payload).data;

            let chopperModelDutiesList = myChopperModelDuties.map(cmd => (
                {
                    id: cmd[0],
                    ChopperModelID: cmd[1],
                    DutyID: cmd[2],
                    DutyName: cmd[3]
                }
            ));

            setChopperModelDuties(chopperModelDutiesList);

        });

    }, [chopperModels]);

    //Get material types
    useEffect(() => {

        fetchWithRetries(3, GetMaterialTypes, (payload) => {

            let myMaterialTypes = JSON.parse(payload).data;

            let materialTypesList = myMaterialTypes.map(cmt => (

                {
                    MaterialID: cmt[0],
                    MaterialName: cmt[1],
                    DutyID: cmt[2],
                    DutyName: cmt[3]

                }
            ));

            setMaterialTypes(materialTypesList);

        });

    }, []);

    // set default values for the picture selections
    useEffect(() => {
        if (chopper.MotorPositionID) {
            const defaultMotorPosition = motorPositions.find(mp => mp.id == chopper.MotorPositionID);
            setSelectedMotorPosition(defaultMotorPosition || {});
        }

        if (chopper.CutterHeadPositionID) {
            const defaultCutterHeadPosition = cutterHeadPositions.find(chp => chp.id == chopper.CutterHeadPositionID);
            setSelectedCutterHeadPosition(defaultCutterHeadPosition || {});
        }

        if (chopper.CutterMountingArrangementID) {
            const defaultCutterMountingArrangement = cutterMountingArrangements.find(cma => cma.id == chopper.CutterMountingArrangementID);
            setSelectedCutterMountingArrangement(defaultCutterMountingArrangement || {});
        }

        if (chopper.TrimRemovalMethodID) {
            const defaultTrimRemoval = trimRemovalMethods.find(tr => tr.id == chopper.TrimRemovalMethodID);
            setSelectedTrimRemoval(defaultTrimRemoval || {});
        }

        if (chopper.ChopperModelID) {
            const defaultModel = chopperModels.find(m => m.id == chopper.ChopperModelID);
            setSelectedModel(defaultModel || null);
        }

    }, [chopper, motorPositions, cutterHeadPositions, cutterMountingArrangements, trimRemovalMethods, chopperModels]);

    // Update the cutter rotating speed whenever MaterialSpeed, DesiredPieceSize, or BladesInCutter changes
    useEffect(() => {
        const rpm = calculateRPM();
        setCutterRotatingSpeed(rpm);
    }, [chopper.MaterialSpeed, chopper.DesiredPieceSize, chopper.BladesInCutter]);

    //debug
    useEffect(() => {

        console.log(
            "\nChopper: ", chopper
        );

    }, [chopper]);

    const handleSubmit = (e) => {
        const c = chopper;

        CreateUpdateChoppers(
            c.ChopperID ?? "",
            c.ChopperName ?? "",
            c.CreatedByID ?? "",
            c.ChopperModelID ?? "",
            c.MaterialTypeID ?? "",
            c.MotorPositionID ?? "",
            c.CutterHeadPositionID ?? "",
            c.CutterMountingArrangementID ?? "",
            c.TrimRemovalMethodID ?? "",
            c.MaterialThickness ?? "",
            c.MaterialSpeed ?? "",
            c.MaterialWidth ?? "",
            c.InletDiameter ?? "",
            c.AirflowThroughCutter ?? "",
            c.BladesInCutter ?? "",
            c.DesiredPieceSize ?? "",
            c.CutterRotatingSpeed ?? "",
            c.PressureLoss ?? "",
            c.Knives ?? "",
            c.Bearings ?? "",
            c.OilMist ?? "",
            c.TrimGeneratedBy ?? "",
            c.PaintColor ?? "",
            c.Voltage ?? "",
            c.FlyWheel ?? "",
            c.TrimsPerMachine ?? "",
            c.NumberOfMachines ?? "",
            c.PaperGrades ?? "",
            c.Notes ?? ""
        ).then((response) => {
            if (response.success) {
                toast.success("Chopper details saved successfully!");
            } else {
                toast.error("Error saving chopper details: " + response.message);
            }
        });
    };

    const calculateRPM = () => {

        // if either value is not a number, return 0
        if (isNaN(chopper.MaterialSpeed) || isNaN(chopper.DesiredPieceSize)) {
            console.log("Invalid input: MaterialSpeed or DesiredPieceSize is not a number.");
            return 0;
        }
        // if either value is 0, return 0
        if (chopper.MaterialSpeed == 0 || chopper.DesiredPieceSize == 0) {
            console.log("Invalid input: MaterialSpeed or DesiredPieceSize is 0.");
            return 0;
        }
        // if either value is negative, return 0
        if (chopper.MaterialSpeed < 0 || chopper.DesiredPieceSize < 0) {
            console.log("Invalid input: MaterialSpeed or DesiredPieceSize is negative.");
            return 0;
        }
        // if either value is not a number, return 0
        if (isNaN(chopper.MaterialSpeed) || isNaN(chopper.DesiredPieceSize)) {
            console.log("Invalid input: MaterialSpeed or DesiredPieceSize is not a number.");
            return 0;
        }

        // if blades is not a number, return 0
        if (isNaN(chopper.BladesInCutter)) {
            console.log("Invalid input: BladesInCutter is not a number.");
            return 0;
        }

        // speed (fpm) * 12 / desired piece size (in) = rpm

        let calculatedRPM = Math.round((chopper.MaterialSpeed * 12) / chopper.DesiredPieceSize) / chopper.BladesInCutter;

        setChopper({ ...chopper, CutterRotatingSpeed: calculatedRPM });

        return calculatedRPM;
    }

    const getBorderStyle = (selectedItem, config) => {
        return selectedItem && selectedItem.Letter == config.Letter
            ? "4px solid var(--bs-danger)"
            : "1px solid var(--bs-secondary)";
    };

    const getOpacity = (selectedItem, config) => {
        return selectedItem && selectedItem.Letter == config.Letter ? 1 : 0.5;
    }

    const StatBar = ({ label, value, min, max }) => {
        // Define 10 equal increments
        const step = (max - min) / 100;
        const roundedValue = Math.round((value - min) / step) * step + min;

        // Calculate percentage with 5% minimum bar length
        let percentage = ((roundedValue - min) / (max - min)) * 100;
        percentage = Math.min(Math.max(percentage, 5), 100);

        return (
            <>
                <div style={{ marginBottom: "4px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{label}: </span>
                    <span>{value.toLocaleString('en-US')}</span>
                </div>
                <div className="progress" style={{ marginBottom: "4px" }}>
                    <div
                        className="progress-bar progress-bar-striped"
                        role="progressbar"
                        style={{ width: `${percentage}%` }}
                        aria-valuenow={value}
                        aria-valuemin={min}
                        aria-valuemax={max}>
                    </div>
                </div>
            </>
        );
    };

    const DutyIndicator = ({ duty }) => {

        const isActive = (type) => duty.includes(type);

        const getColor = (type) => {
            return "var(--bs-purple)";
            // if (type === "Light") return "var(--bs-success)";   // green
            // if (type === "Medium") return "var(--bs-warning)";  // yellow
            // if (type === "Heavy") return "var(--bs-danger)";   // red
        };

        return (
            <div style={{ display: "flex", gap: "4px", marginBottom: "4px" }}>
                {["Light", "Medium", "Heavy"].map((type) => (
                    <div
                        key={type}
                        title={type}
                        style={{
                            width: "96px",
                            padding: "2px 6px",
                            fontSize: "10px",
                            borderRadius: "16px",
                            backgroundColor: isActive(type) ? getColor(type) : "var(--bs-light)",
                            border: "1px solid var(--bs-secondary)",
                            color: isActive(type) ? "#158cba" : "var(--bs-secondary)",
                            textAlign: "center",
                            opacity: isActive(type) ? 1 : 0.5,
                            color: isActive(type) ? "var(--bs-light)" : "var(--bs-dark)"
                        }}>
                        {type} Duty
                    </div>
                ))}
            </div>
        );
    };

    document.title = "Trim Chopper Details";
    return (
        <div className="ChoppersDetail">
            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px", fontSize: "16px" }}>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%", marginBottom: "16px" }}>
                            <button className="btn btn-default" onClick={() => navigate("/Choppers")}>Back to Choppers</button>
                        </div>

                        <div className="card">
                            <div className="card-header" style={{ backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                                <span style={{ fontSize: "24px" }}>{chopper["ChopperName"]}</span>
                            </div>
                            <div className="card-body">

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Chopper Details</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="chopperID">Chopper ID</label>
                                            <input type="text" className="form-control" id="chopperID" defaultValue={chopper["ChopperID"]} disabled />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="chopperName">Chopper Name</label>
                                            <input type="text" className="form-control" id="chopperName" defaultValue={chopper["ChopperName"]}
                                                onChange={(e) => setChopper({ ...chopper, ChopperName: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Material Specifications</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="material">Material Type</label>
                                            <select className="form-select" id="materialtype" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["MaterialTypeID"]}
                                                onChange={(e) => setChopper({ ...chopper, MaterialTypeID: e.target.value })}
                                            >
                                                <option value="">Select Material Type</option>

                                                {["Light", "Medium", "Heavy"].map((duty) => {
                                                    const materialsInGroup = materialTypes.filter(material => material.DutyName == duty);
                                                    if (materialsInGroup.length == 0) return null;

                                                    return (
                                                        <optgroup key={duty} label={`${duty} Duty`}>
                                                            {materialsInGroup.map((material, index) => (
                                                                <option key={index} value={material.MaterialID}>
                                                                    {material.MaterialName}
                                                                </option>
                                                            ))}
                                                        </optgroup>
                                                    );
                                                })}
                                            </select>

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="materialThickness">Material Thickness (mm)</label>
                                            <input type="number" className="form-control" id="materialThickness"
                                                defaultValue={chopper["MaterialThickness"]}
                                                onChange={(e) => setChopper({ ...chopper, MaterialThickness: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>
                                            <label htmlFor="materialSpeed">Material Speed (fpm)</label>
                                            <input type="number" className="form-control" id="materialSpeed"
                                                defaultValue={chopper["MaterialSpeed"]}
                                                onChange={(e) => setChopper({ ...chopper, MaterialSpeed: e.target.value })}
                                            />
                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>
                                            <label htmlFor="materialWidth">Material Width (in)</label>
                                            <input type="number" className="form-control" id="materialWidth"
                                                defaultValue={chopper["MaterialWidth"]}
                                                onChange={(e) => setChopper({ ...chopper, MaterialWidth: e.target.value })}
                                            />
                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="desiredPieceSize">Desired Piece Size After Cutter (in)</label>
                                            <input type="number" className="form-control" id="desiredPieceSize"
                                                defaultValue={chopper["DesiredPieceSize"]}
                                                onChange={(e) => setChopper({ ...chopper, DesiredPieceSize: e.target.value })}
                                            />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                        </div>

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Chopper Specifications</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="rotatingBlades">Rotating Blades in Cutter</label>
                                            <div style={{ position: "relative" }}>
                                                <select className="form-select" id="rotatingBlades"
                                                    value={chopper["BladesInCutter"]}
                                                    style={{ fontSize: "16px", height: "38px" }}
                                                    onChange={(e) => setChopper({ ...chopper, BladesInCutter: e.target.value })}
                                                >
                                                    <option value="">Select Number of Blades</option>
                                                    <option value="2">2</option>
                                                    <option value="4">4</option>
                                                </select>

                                            </div>

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="cutterRotatingSpeed"
                                                onClick={(e) => { toast(`ℹ️ Calculated RPM = ([Material Speed in FPM] * 12) / [Desired Piece Size] / [Number of Blades]`); }}
                                            >
                                                Cutter Rotating Speed (RPM)
                                            </label>
                                            <input type="number" className="form-control" id="cutterRotatingSpeed" style={{ pointerEvents: "none" }}
                                                value={cutterRotatingSpeed} readOnly
                                            />

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="calculatedPressureLoss">Calculated Pressure Loss</label>
                                            <input type="number" className="form-control" id="calculatedPressureLoss"
                                                defaultValue={chopper["PressureLoss"]}
                                                onChange={(e) => setChopper({ ...chopper, PressureLoss: e.target.value })}
                                            />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="calculatedAirflow">Calculated Airflow Through Cutter (cfm)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="calculatedAirflow"
                                                defaultValue={chopper["AirflowThroughCutter"]}
                                                onChange={(e) => setChopper({ ...chopper, AirflowThroughCutter: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="systemDuctDiameter">System Duct Diameter Into Chopper (in)</label>
                                            <input type="number" className="form-control" id="systemDuctDiameter"
                                                defaultValue={chopper["InletDiameter"]}
                                                onChange={(e) => setChopper({ ...chopper, InletDiameter: e.target.value })}
                                            />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="SelectKnives">Knives</label>
                                            <select className="form-select" id="SelectKnives" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["Knives"]}
                                                onChange={(e) => setChopper({ ...chopper, Knives: e.target.value })}
                                            >
                                                <option value="">Select Knives</option>
                                                <option value="Standard HcHc">Standard HcHc</option>
                                                <option value="NEOR">NEOR</option>
                                                <option value="Carbide">Carbide</option>
                                                <option value="Serrated">Serrated</option>
                                            </select>

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="voltage">Voltage</label>
                                            <select className="form-select" id="voltage" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["Voltage"]}
                                                onChange={(e) => setChopper({ ...chopper, Voltage: e.target.value })}
                                            >
                                                <option value="">Select Voltage</option>
                                                <option value="115/230v 1Ph">115/230v 1Ph</option>
                                                <option value="230/460v 3Ph">230/460v 3Ph</option>
                                                <option value="575v 3Ph">575v 3Ph</option>
                                            </select>

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="bearings">Bearings</label>
                                            <select className="form-select" id="bearings" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["Bearings"]}
                                                onChange={(e) => setChopper({ ...chopper, Bearings: e.target.value })}
                                            >
                                                <option value="">Select Bearings</option>
                                                <option value="Standard">Standard</option>
                                                <option value="Precision">Precision</option>
                                            </select>

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="flyWheel">Fly Wheel</label>
                                            <select className="form-select" id="flyWheel" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["FlyWheel"]}
                                                onChange={(e) => setChopper({ ...chopper, FlyWheel: e.target.value })}
                                            >
                                                <option value="">Select Fly Wheel</option>
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="oilMist">Oil Mist</label>
                                            <select className="form-select" id="oilMist" style={{ fontSize: "16px", height: "38px" }}
                                                value={chopper["OilMist"]}
                                                onChange={(e) => setChopper({ ...chopper, OilMist: e.target.value })}
                                            >
                                                <option value="">Select Oil Mist</option>
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="trimGeneratedBy">Trim Generated By</label>
                                            <input type="text" className="form-control" id="trimGeneratedBy"
                                                defaultValue={chopper["TrimGeneratedBy"]}
                                                onChange={(e) => setChopper({ ...chopper, TrimGeneratedBy: e.target.value })}
                                            />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="trimsPerMachine">Trims per Machine</label>
                                            <input type="number" className="form-control" id="trimsPerMachine"
                                                defaultValue={chopper["TrimsPerMachine"]}
                                                onChange={(e) => setChopper({ ...chopper, TrimsPerMachine: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="paintColor" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Paint Color (4-digit)</label>
                                            <input type="text" className="form-control" placeholder="####" id="paintColor"
                                                defaultValue={chopper["PaintColor"]}
                                                onChange={(e) => setChopper({ ...chopper, PaintColor: e.target.value })}
                                            />
                                            <Link to="https://www.ralcolorchart.com/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: "nowrap", marginRight: "50%", textDecoration: "underline" }}>
                                                RAL Color Chart
                                            </Link>

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            <label htmlFor="numberOfMachines">Number of Machines</label>
                                            <input type="number" className="form-control" id="numberOfMachines"
                                                defaultValue={chopper["NumberOfMachines"]}
                                                onChange={(e) => setChopper({ ...chopper, NumberOfMachines: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            {/* Paper Grades / Basis Weight / Material to be handled */}
                                            <label htmlFor="paperGrades">Paper Grades / Basis Weight / Material to be handled</label>
                                            <textarea className="form-control" id="paperGrades" rows="5" style={{ minWidth: "98%" }}
                                                defaultValue={chopper["PaperGrades"]}
                                                onChange={(e) => setChopper({ ...chopper, PaperGrades: e.target.value })}
                                            />

                                        </div>

                                        <div style={{ width: "50%", marginTop: "8px" }}>

                                            {/* Notes / Additional Requirements*/}
                                            <label htmlFor="notes">Notes / Additional Requirements</label>
                                            <textarea className="form-control" id="notes" rows="5" style={{ minWidth: "98%" }}
                                                defaultValue={chopper["Notes"]}
                                                onChange={(e) => setChopper({ ...chopper, Notes: e.target.value })}
                                            />

                                        </div>

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Motor Positions</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        {motorPositions.map((config) => (
                                            <div
                                                key={config.Letter}
                                                onClick={() => {
                                                    setSelectedMotorPosition(config);
                                                    setChopper({ ...chopper, MotorPositionID: config.id });
                                                }
                                                }
                                                style={{
                                                    height: "192px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: "1 1 19%",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    margin: "2px",
                                                    border: getBorderStyle(selectedMotorPosition, config),
                                                    opacity: getOpacity(selectedMotorPosition, config),
                                                    borderRadius: "8px",
                                                    boxSizing: "border-box",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <div style={{ height: "80%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "128px" }}>
                                                    <img src={config.Path} draggable={false} alt={config.Description} style={{ width: "auto", maxWidth: "95%", height: "auto", maxHeight: "95%" }} />
                                                </div>
                                                <div style={{ height: "20%", width: "100%", padding: "4px" }}>
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{config.Description}</span>
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Cutter Head Positions</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        {cutterHeadPositions.map((config) => (
                                            <div
                                                key={config.Letter}
                                                onClick={() => {
                                                    setSelectedCutterHeadPosition(config);
                                                    setChopper({ ...chopper, CutterHeadPositionID: config.id });
                                                }
                                                }
                                                style={{
                                                    height: "192px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: "1 1 19%",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    margin: "2px",
                                                    border: getBorderStyle(selectedCutterHeadPosition, config),
                                                    opacity: getOpacity(selectedCutterHeadPosition, config),
                                                    borderRadius: "8px",
                                                    boxSizing: "border-box",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <div style={{ height: "80%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "128px" }}>
                                                    <img src={config.Path} draggable={false} alt={config.Description} style={{ width: "auto", maxWidth: "95%", height: "auto", maxHeight: "95%" }} />
                                                </div>
                                                <div style={{ height: "20%", width: "100%", padding: "4px" }}>
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{config.Description}</span>
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Cutter Mounting Arrangements</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        {cutterMountingArrangements.map((config) => (
                                            <div
                                                key={config.Letter}
                                                onClick={() => setSelectedCutterMountingArrangement(config)}
                                                style={{
                                                    height: "192px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: "1 1 19%",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    margin: "2px",
                                                    border: getBorderStyle(selectedCutterMountingArrangement, config),
                                                    opacity: getOpacity(selectedCutterMountingArrangement, config),
                                                    borderRadius: "8px",
                                                    boxSizing: "border-box",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <div style={{ height: "80%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "128px" }}>
                                                    <img src={config.Path} draggable={false} alt={config.Description} style={{ width: "auto", maxWidth: "95%", height: "auto", maxHeight: "95%" }} />
                                                </div>
                                                <div style={{ height: "20%", width: "100%", padding: "4px" }}>
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{config.Description}</span>
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Trim Removals</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "1%", width: "98%" }}>

                                        {trimRemovalMethods.map((config) => (
                                            <div
                                                key={config.Letter}
                                                onClick={() => setSelectedTrimRemoval(config)}
                                                style={{
                                                    height: "256px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    flex: "1 1 19%",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    margin: "2px",
                                                    border: getBorderStyle(selectedTrimRemoval, config),
                                                    opacity: getOpacity(selectedTrimRemoval, config),
                                                    borderRadius: "8px",
                                                    boxSizing: "border-box",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <div style={{ height: "60%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "128px" }}>
                                                    <img src={config.Path} draggable={false} alt={config.Description} style={{ width: "auto", maxWidth: "95%", height: "auto", maxHeight: "95%" }} />
                                                </div>
                                                <div style={{ height: "40%", width: "100%", padding: "4px" }}>
                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>{config.Description}</span>
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                </div>

                                <h3 className="card-title" style={{ color: "#158cba", fontWeight: "bold", marginLeft: "8px" }}>Chopper Models</h3>
                                <div className="form-group">

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", flexWrap: "wrap", margin: "1%", width: "98%" }}>

                                        {chopperModels.map((model) => {
                                            const AirCapacities = chopperModels.map(m => Number(m.AirCapacity));
                                            const MotorHPs = chopperModels.map(m => Number(m.MotorHP));
                                            const MaxRPMs = chopperModels.map(m => Number(m.MaxRPM));

                                            const statRanges = {
                                                AirCapacity: { min: Math.min(...AirCapacities), max: Math.max(...AirCapacities) },
                                                MotorHP: { min: Math.min(...MotorHPs), max: Math.max(...MotorHPs) },
                                                MaxRPM: { min: Math.min(...MaxRPMs), max: Math.max(...MaxRPMs) },
                                            };

                                            return (
                                                <div
                                                    key={model.id}
                                                    onClick={() => setSelectedModel(model)}
                                                    style={{
                                                        minWidth: "48%",
                                                        margin: "1%",
                                                        padding: "8px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        border: selectedModel?.id === model.id ? "4px solid var(--bs-danger)" : "1px solid var(--bs-secondary)",
                                                        opacity: selectedModel?.id === model.id ? 1 : 0.66,
                                                        borderRadius: "8px",
                                                        cursor: "pointer",
                                                        boxSizing: "border-box",
                                                        backgroundColor: "var(--bs-light)"
                                                    }}
                                                >
                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "4px" }}>
                                                            <h3 style={{ margin: "4px 0", color: "var(--bs-dark)", fontWeight: "bold" }}>
                                                                {model.ManufacturerName} Model {model.ModelName}
                                                            </h3>

                                                            <a href={model.Link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>More Info</a>

                                                        </div>

                                                        <hr style={{ margin: "4px", backgroundColor: "var(--bs-dark)", height: "1px", border: "none" }} />

                                                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                            <span style={{ fontWeight: "bold" }}>Suitable for:</span>
                                                            <DutyIndicator duty={chopperModelDuties.filter(d => d.ChopperModelID == model.id).map(d => d.DutyName)} />

                                                        </div>

                                                        <hr style={{ margin: "4px", backgroundColor: "var(--bs-dark)", height: "1px", border: "none" }} />

                                                        <span style={{ fontWeight: "bold", fontSize: "14px", color: "var(--bs-dark)" }}> Inlet Width: </span>
                                                        <span style={{ color: "var(--bs-dark)" }}>{model.InletWidth.toLocaleString('en-US')}"</span>


                                                        <hr style={{ margin: "4px", backgroundColor: "var(--bs-dark)", height: "1px", border: "none" }} />

                                                        <StatBar label="Air Capacity (cfm)" value={Number(model.AirCapacity)} min={statRanges.AirCapacity.min} max={statRanges.AirCapacity.max} />
                                                        <StatBar label="Motor (hp)" value={Number(model.MotorHP)} min={statRanges.MotorHP.min} max={statRanges.MotorHP.max} />
                                                        <StatBar label="Max RPM" value={Number(model.MaxRPM)} min={statRanges.MaxRPM.min} max={statRanges.MaxRPM.max} />

                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </div>

                                </div>

                            </div>
                        </div>

                        <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "20px" }}>

                            <Link to="/Choppers" className="btn btn-default" style={{ marginRight: "4px" }}>Back to Choppers</Link>

                        </div>

                    </div>

                    {/* Fixed Position Save button */}
                    <div style={{ position: "fixed", bottom: "16px", right: "16px" }}>
                        <button className="btn btn-primary" onClick={handleSubmit}>Save Changes</button>
                    </div>
                </>
            }
        </div>
    );
}

export default ChoppersDetail;